import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Composant SEO — PEFEP Site
 * Injecte dans le <head> les balises propres a chaque page.
 * Prerequis : <HelmetProvider> doit envelopper <App /> dans index.js.
 */

const SITE_URL = 'https://pefep.site';
const NOM_SITE = 'PEFEP Site';
const IMAGE_PAR_DEFAUT = SITE_URL + '/og-image.png';

function SEO({
  titre,
  description,
  chemin = '/',
  image = IMAGE_PAR_DEFAUT,
  indexable = true,
  jsonLd = null,
}) {
  const urlCanonique = SITE_URL + (chemin === '/' ? '/' : chemin);

  return (
    <Helmet>
      {/* --- Base --- */}
      <html lang="fr" />
      <title>{titre}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={urlCanonique} />

      {/* --- Indexation --- */}
      <meta
        name="robots"
        content={
          indexable
            ? 'index, follow, max-image-preview:large, max-snippet:-1'
            : 'noindex, follow'
        }
      />

      {/* --- Open Graph (Facebook, LinkedIn, WhatsApp) --- */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={NOM_SITE} />
      <meta property="og:locale" content="fr_HT" />
      <meta property="og:title" content={titre} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={urlCanonique} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content="PEFEP Site — votre site web professionnel en quelques minutes"
      />

      {/* --- Twitter / X --- */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={titre} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* --- Donnees structurees --- */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export default SEO;